import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { AuthShell } from "@/pages/Login";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("If an account exists, a reset link was created (see backend logs).");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title={t("auth.forgotTitle")} subtitle={t("auth.forgotSubtitle")}>
      {sent ? (
        <div className="space-y-4">
          <p className="text-foreground">A password reset link has been generated. Check the backend logs for the link, then open it to set a new password.</p>
          <Link to="/login"><Button variant="outline" className="w-full h-12 rounded-xl">{t("common.back")}</Button></Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <div className="space-y-2">
            <Label htmlFor="email">{t("auth.email")}</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="h-12 rounded-xl" data-testid="forgot-email" />
          </div>
          <Button type="submit" disabled={loading} className="w-full h-12 rounded-xl bg-secondary hover:bg-secondary/90" data-testid="forgot-submit">
            {loading ? t("common.loading") : t("auth.sendReset")}
          </Button>
          <p className="text-center text-sm"><Link to="/login" className="text-accent font-semibold hover:underline">{t("common.back")}</Link></p>
        </form>
      )}
    </AuthShell>
  );
}
